import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import type { PublicSummary } from "@/v2-status-client/status/status.types"
import StatusKpiTile from "@/v2-status-client/status/kpis/StatusKpiTile"
import { buildStatusKpiTiles } from "@/v2-status-client/status/kpis/status.kpis.utils"

export type StatusKpisProps = ComponentProps<"section"> & {
  summary: PublicSummary
}

// Top-of-page KPI strip. Replaces the previous outage banner;
// instead of a single "operational / partial / major" status,
// customers see four neutral tiles with the actual numbers and
// can decide for themselves whether the picture is calm or not.
//
// Layout: 2-col on phones, 4-col on small+ screens. CSS-grid
// handles the wrapping so we don't have to nest flex rows.
function StatusKpis(props: Readonly<StatusKpisProps>) {
  const { summary, className, ...sectionProps } = props
  const tiles = buildStatusKpiTiles(summary)
  return (
    <section
      className={cn(
        "grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4",
        className,
      )}
      aria-label="Service status overview"
      {...sectionProps}
    >
      {tiles.map((t) => (
        <StatusKpiTile
          key={t.id}
          label={t.label}
          value={t.value}
          sub={t.sub}
          tone={t.tone}
        />
      ))}
    </section>
  )
}

export default StatusKpis
